import SortingMobile from './sorting-mobile';

export default SortingMobile;